import { Box } from "@mui/material";
import { useContext, useMemo } from "react";
import { useTranslation } from "react-i18next";
import { StockEditionsEnum } from "../api";
import { AnimatedView } from "../components/utils/AnimatedView";
import PageTitle from "../components/utils/PageTitle";
import AboutUs from "../components/view/AboutUs";
import Intro from "../components/view/Intro";
import Showroom from "../components/view/Showroom";
import SpecialProductsSelection from "../components/view/SpecialProductsSelection";
import { Anchors } from "../constants/routes";
import { ProductsContext } from "../context/ProductsContext";

const HomePage = () => {
  const { t } = useTranslation();
  const { products, loading } = useContext(ProductsContext);

  const newProducts = useMemo(
    () => products?.filter((product) => product.editions?.includes(StockEditionsEnum.New)),
    [products]
  );

  const preparingProducts = useMemo(
    () => products?.filter((product) => product.editions?.includes(StockEditionsEnum.Preparing)),
    [products]
  );

  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        mb: 5,
        gap: 8
      }}>
      <PageTitle title={undefined} />
      <Intro />
      <AnimatedView>
        <SpecialProductsSelection
          title={t("home.newProducts")}
          products={newProducts}
          loading={loading}
          anchor={Anchors.news}
        />
      </AnimatedView>
      <AnimatedView>
        <SpecialProductsSelection
          title={t("home.preparingProducts")}
          products={preparingProducts}
          loading={loading}
          anchor={Anchors.preparing}
        />
      </AnimatedView>

      <AboutUs />
      <Showroom />
    </Box>
  );
};

export default HomePage;
